<template>
  <div class="growth">
    <div v-for="(item, index) in data" :key="index" class="growth__item">
      <div class="growth__item--value">{{ getDisplayValue(item) }}</div>
      <div class="growth__item--label">{{ getDisplayLabelYear(item) }}</div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "Growth",
  data() {
    return {};
  },
  methods: {
    getDisplayValue(item) {
      const symbol = item.DELTA_VALUE_PERC > 0 ? "+" : "";
      return `${symbol} ${item.DELTA_VALUE_PERC.toFixed(0)} % growth`;
    },
    getDisplayLabelYear(item) {
      return `compared to  ${item.REFERENCE_YEARS[1]}`;
    },
  },
  computed: {
    ...mapGetters({
      data: "data/getGrowth",
    }),
  },
};
</script>

<style lang="scss" scoped>
.growth {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  &__item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex-grow: 1;
    border: $white-border;
    border-left: none;
    width: 100%;
    height: 100%;

    &:last-of-type {
      border-top: none;
    }

    &--value {
      @include slider-S;
      color: $primary-yellow;
    }
    &--label {
      @include dida-S;
      color: $ui-white;
    }
  }
}

.mobile {
  .growth {
    &__item {
      padding: 2.3vh 0;
    }
  }
}
.tablet {
  .growth {
    height: 100%;
    &__item {
      border: none;
      padding: 2.3vh 0;
      &:not(:last-child) {
        border-bottom: $white-border;
      }
    }
  }
}
</style>
